// extracted by css-extract-rspack-plugin
export default {"bui-VisuallyHidden":"OoBjYfKAfnY5kPsk"};